import React, { useState } from 'react';
import DashboardLayout from '../components/Dashboard/DashboardLayout';
import UploadMaterial from '../components/Admin/UploadMaterial';
import ManageMaterials from '../components/Admin/ManageMaterials';
import ManageSubjects from '../components/Admin/ManageSubjects';
import UserManagement from '../components/Admin/UserManagement';
import AccessLogs from '../components/Admin/AccessLogs';
import ManageAnnouncements from '../components/Admin/ManageAnnouncements';
import ManageContributions from '../components/Admin/ManageContributions';
import AdminSupportPanel from '../components/Admin/AdminSupportPanel';
import PremiumSettings from '../components/Admin/PremiumSettings';
import AdminTimetable from '../components/Admin/AdminTimetable';
import AdminNotifications from '../components/Admin/AdminNotifications';
import './AdminPage.scss';

const AdminPage = () => {
  const [activeTab, setActiveTab] = useState('upload');

  const tabs = [
    { key: 'upload',         label: 'Upload Material' },
    { key: 'manageMaterials',label: 'Manage Materials' },
    { key: 'contributions',  label: 'Contributions' },
    { key: 'support',        label: 'Support Chats' },
    { key: 'manageSubjects', label: 'Manage Subjects' },
    { key: 'manageAnnouncements', label: 'Announcements' },
    { key: 'userManagement', label: 'User Management' },
    { key: 'accessLogs',     label: 'Access Logs' },
    { key: 'timetable',      label: '📅 Timetable' },
    { key: 'notifications',  label: '🔔 Notifications' },
    { key: 'premiumSettings',label: '⭐ Premium' },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'upload':              return <UploadMaterial />;
      case 'manageMaterials':     return <ManageMaterials />;
      case 'contributions':       return <ManageContributions />;
      case 'support':             return <AdminSupportPanel />;
      case 'manageSubjects':      return <ManageSubjects />;
      case 'userManagement':      return <UserManagement />;
      case 'accessLogs':          return <AccessLogs />;
      case 'manageAnnouncements': return <ManageAnnouncements />;
      case 'premiumSettings':     return <PremiumSettings />;
      case 'timetable':           return <AdminTimetable />;
      case 'notifications':       return <AdminNotifications />;
      default:                    return <UploadMaterial />;
    }
  };

  return (
    <DashboardLayout>
      <div className="admin-page">
        <h2>Admin Panel</h2>
        <nav className="admin-tabs">
          {tabs.map(tab => (
            <button
              key={tab.key}
              className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </nav>
        <div className="admin-content">
          {renderContent()}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AdminPage;
